import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from '../../infrastructure/services/settings.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { KeyValueBuilderComponent } from '../../helpers/components/kevValueBuilder/keyValueBuilder.component';
import { AlertService } from '../../infrastructure/services/alert.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectsService, Opcion } from '../../infrastructure/services/selects.service';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: 'settings.entidad.component.html'
})
export class SettingsEntidadComponent implements OnInit {
  tipo = 'Settings';

  @ViewChild('keyValue') keyValue: KeyValueBuilderComponent;
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  setting: any;
  selectSettings: any[] = [];
  parsedSettings: string;
  opcionesSubscription = [];

  constructor(private aRoute: ActivatedRoute,
              private modalService: NgbModal,
              private settingsService: SettingsService,
              private alertService: AlertService,
              public ngxSmartModalService: NgxSmartModalService,
              public selectService: SelectsService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];

      this.settingsService
        .getByLevel(this.tipo, this.codSistema, this.codNegocio, this.codProducto)
          .then(setting => this.init(setting));
    });

    const selectKeys = this.selectService.getKeys();
    for (const key in selectKeys) {
      const tipoSelect = selectKeys[key];
      this.opcionesSubscription[tipoSelect] = this.selectService.getSelectFor(tipoSelect);
    }
  }

  init(setting) {
    this.setting = {...setting};
    const valor = JSON.parse(setting.valor);
    if (valor) {
      this.construirConjuntos(valor.Settings);
    }
  }

  construirConjuntos(settings) {
    const selectKeys = this.selectService.getKeys();

    // Las settings cuyo valor son textos simples
    const textSettings = [];

    // Las settings cuyo valor debe obtenerse de un Select
    let selectSettings = [];

    // Separamos la lista de settings en dos listas,
    // una para las settings simples y otra para
    // las settings que son selects
    settings.forEach(setting => {
      if (selectKeys.indexOf(setting.Key) >= 0) {
        selectSettings.push(setting);
        return;
      }
      textSettings.push(setting);
    });


    if (!selectSettings.length) {
      selectSettings = this.inicializarSelectSettings();
    }

    this.selectSettings = selectSettings;
    this.parsedSettings = JSON.stringify(textSettings);
  }

  inicializarSelectSettings() {
    const selectKeys = this.selectService.getKeys();
    const result = [];
    for (const key in selectKeys) {
      const tipoSelect = selectKeys[key];
      result.push({
        Key: tipoSelect,
        Valor: null,
      });
    }
    return result;
  }

  guardar() {
    this.buildForSave();

    this.settingsService.crearOEditar(this.setting, this.codSistema, this.codNegocio, this.codProducto)
      .then(res => {
        // this.init(res);
        this.alertService.showSuccessMessage('GUARDADO_CORRECTAMENTE');
      });
  }

  open(content) {
    this.modalService.open(content)
      .result.then((result) => this.resetearPorDefault(), (reason) => { /* Do nothing */ });
  }

  resetearPorDefault() {
    this.settingsService.remove(this.tipo, this.codSistema, this.codNegocio, this.codProducto)
      .then(res => {
        this.init(res);
        this.alertService.showSuccessMessage('RESETEADO_CORRECTAMENTE');
      });
  }

  buildForSave() {
    let allValues = [];

    // Obtenemos los items del keyValue builder
    const values = this.keyValue.items;
    const parsedValues = JSON.parse(values);

    // Obtenemos los items de los selects
    allValues = parsedValues.concat(this.selectSettings);

    // Armamos el json
    this.setting.valor = `{ "Settings": ${JSON.stringify(allValues)}}`;
  }

  seleccionarOpcion(setting, opcion) {
    setting.Valor = opcion.codigo;
  }

  getDescripcion(opciones: Opcion[], valor) {
    const opcion = opciones.find(opc => opc.codigo === valor);
    if (opcion) {
      return opcion.descripcion;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/settingsEntidad/settings.entidad.component.ts